export const runtimeConfig = window["runConfig"] || {};

function isRuntimePlaceholder(value) {
  if (!value) return true;
  return /^#\{.+\}#$/.test(value);
}

export function getRecaptchaSiteKey() {
  const runtimeKey = runtimeConfig?.REACT_APP_RECAPTCHA_SITE_KEY;

  if (runtimeKey && !isRuntimePlaceholder(runtimeKey)) {
    return runtimeKey;
  }

  return process.env.REACT_APP_RECAPTCHA_SITE_KEY;
}

export function getApiBaseUrl() {
  const runtimeUrl = runtimeConfig?.REACT_APP_API_BASE_URL;

  if (runtimeUrl && !isRuntimePlaceholder(runtimeUrl)) {
    return runtimeUrl;
  }

  return process.env.REACT_APP_API_BASE_URL;
}
